import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postLogout } from '@api';

export const securityAuthenticationLogoutPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		allowUnauthorized: true
	},
	name: 'SecurityAuthenticationLogout',
	receive: false,
	request: true,
	requestHandler: postLogout
});
